import { Button,Snackbar } from "@material-ui/core";
import { useEffect, useState } from "react";
import localforage from "localforage";
import { REACT_APP_VERSION as currentBuildVersion } from "../../utilities/GlobalConstants";

const ReloadWebAppNotification = () => {
  const [isSnackbarVisible, setIsSnackBarVisible] = useState(false);
  useEffect(() => {
      const previousBuildVersion = localStorage.getItem('build-number');
      if(process.env.NODE_ENV !== "development") {
        if (previousBuildVersion) {
          if ((previousBuildVersion !== currentBuildVersion)) {
            setIsSnackBarVisible(true);
          }
        } else {
          // If previousBuildNumber does not exist, it means this is the first run
          // Treat this as a new build
          setIsSnackBarVisible(false);
          refreshCacheAndReload();
        }
      } 
    }, []);

    const refreshCacheAndReload = () => {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then((names) => {
          for (const name of names) {
            caches.delete(name);
          }
        });
      }
      //will clear redux state stored in indexedDB
      localforage.clear();
      // delete browser cache and hard reload
      localStorage.setItem('build-number', currentBuildVersion);
      window.location.reload();
      window.location.assign('/');
    };

    const action = (
        <Button variant="contained" className="button"  type= 'button' onClick={refreshCacheAndReload}>Relaunch to update</Button> 
    )
    return (
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          style={{ marginTop: '50px' }}
          open={isSnackbarVisible}  
          message={ 'New app version available. \
              Click on Relaunch to update  to view new changes.'
            }
          action={action}
      />
    )
}

export default ReloadWebAppNotification;